<template>
    <div class="w-full">
        <div v-if="itemsCurrent.length" class="flex flex-col gap-2">
            <div
                v-for="(item, index) in itemsCurrent"
                :key="item.id"
                class="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl border border-brand-blue bg-theme-input transition-shadow hover:shadow-sm"
            >
                <div
                    class="flex-shrink-0 w-11 h-11 bg-stack-primary rounded-lg flex items-center justify-center"
                >
                    <span
                        class="text-white text-xs font-bold uppercase leading-none"
                    >
                        {{ getFileExt(item.url) }}
                    </span>
                </div>

                <div class="flex-1 min-w-0">
                    <a
                        :href="`/app/files/detail/${item.id}`"
                        target="_blank"
                        rel="noopener"
                        class="text-theme-primary text-sm font-medium truncate block hover:underline"
                    >
                        {{ item.alt | cut(50) }}
                    </a>
                    <a
                        :href="item.url"
                        target="_blank"
                        rel="noopener"
                        class="text-theme-muted text-xs hover:text-stack-primary transition-colors"
                    >
                        Ver archivo
                    </a>
                </div>

                <span
                    class="flex-shrink-0 text-xs text-stack-primary bg-theme-input border border-brand-blue rounded-full px-2 py-0.5"
                >
                    #{{ item.id }}
                </span>

                <div v-if="enabled" class="flex flex-col gap-0.5 flex-shrink-0">
                    <button
                        v-if="index !== 0"
                        class="w-6 h-6 rounded flex items-center justify-center text-theme-base hover:text-stack-primary hover:bg-stack-primary/10 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
                        @click="moveOrder(index, index - 1)"
                    >
                        <chevron-up-icon class="w-3.5 h-3.5" />
                    </button>
                    <button
                        v-if="index < itemsCurrent.length - 1"
                        class="w-6 h-6 rounded flex items-center justify-center text-theme-base hover:text-stack-primary hover:bg-stack-primary/10 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
                        @click="moveOrder(index, index + 1)"
                    >
                        <chevron-down-icon class="w-3.5 h-3.5" />
                    </button>
                </div>

                <button
                    v-if="enabled"
                    class="flex-shrink-0 w-7 h-7 rounded-full bg-theme-danger/10 text-danger flex items-center justify-center hover:bg-theme-danger hover:text-white transition-colors"
                    @click="deleteFile(index)"
                >
                    <trash-icon class="w-3.5 h-3.5" />
                </button>
            </div>
        </div>
        <div v-else class="w-full py-4 text-center">
            <span class="text-sm text-theme-muted">
                No se han asociado archivos
            </span>
        </div>

        <div class="w-full mt-3 flex justify-center">
            <custom-tooltip v-if="enabled && $enabledEcommerceOptions" border>
                <button
                    class="rounded-xl border-2 border-dashed border-brand-blue flex items-center justify-center gap-2 h-12 px-6 text-theme-muted hover:border-stack-primary hover:text-stack-primary transition-colors"
                    @click="openNewItem"
                >
                    <plus-icon class="w-4 h-4" />
                    <span class="text-sm font-medium">Agregar archivo</span>
                </button>
                <template #tooltip>Agregar archivos</template>
            </custom-tooltip>
        </div>

        <div>
            <app-dialog v-model="selectFile" size="lg" :persistent="isLoading">
                <template #header>
                    <div class="flex items-center justify-between gap-4">
                        <h3 class="text-base font-semibold text-theme-base">
                            <span v-show="!isOpenFileCreator">
                                Selecciona los archivos
                            </span>
                            <span v-show="isOpenFileCreator">
                                Cargar nuevo archivo
                            </span>
                        </h3>
                        <div class="flex items-center gap-2">
                            <app-button
                                v-show="
                                    !isOpenFileCreator && selectedFiles.length
                                "
                                icon
                                circle
                                @click="pushNewFile"
                            >
                                <check-icon class="w-4 h-4" />
                            </app-button>
                            <custom-tooltip
                                v-if="$ability.hasPermission('file:Create')"
                                border
                                bottom
                            >
                                <app-button
                                    v-if="$ability.hasPermission('file:Update')"
                                    circle
                                    icon
                                    @click="
                                        isOpenFileCreator = !isOpenFileCreator
                                    "
                                >
                                    <chevron-left-icon
                                        v-if="isOpenFileCreator"
                                        class="h-4 w-4"
                                    />
                                    <span v-else>➕</span>
                                </app-button>
                                <template #tooltip>
                                    <span>
                                        {{
                                            isOpenFileCreator
                                                ? "Lista de archivos"
                                                : "Cargar nuevo archivo"
                                        }}
                                    </span>
                                </template>
                            </custom-tooltip>
                        </div>
                    </div>
                </template>

                <div>
                    <div v-if="isOpenFileCreator">
                        <file-uploader
                            v-model="file"
                            type="productFile"
                            auto-approve
                            required-alt
                            @loading="onLoading"
                            @created="selectionUploadFile"
                        />
                    </div>
                    <div v-else>
                        <div
                            class="flex justify-between flex-col lg:flex-row w-full gap-2 mb-4"
                        >
                            <div class="flex items-center gap-2">
                                <custom-input
                                    v-model="keyword"
                                    type="text"
                                    placeholder="Buscar archivo..."
                                    @click-icon="advanceSearch"
                                    @enter="advanceSearch"
                                >
                                    <template #icon> 🔎 </template>
                                </custom-input>
                                <app-button
                                    icon
                                    circle
                                    color="brand-purple"
                                    @click="reloadItems(true)"
                                >
                                    <reload-icon class="h-5 w-5 text-white" />
                                </app-button>
                            </div>

                            <custom-pagination
                                v-model="currentPage"
                                :length="pagesNumber"
                                @input="listItems()"
                            />
                        </div>

                        <div
                            v-if="filesList.length"
                            class="flex flex-col gap-2"
                        >
                            <button
                                v-for="(item, index) in filesList"
                                :key="index"
                                class="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl border transition-all text-left"
                                :class="
                                    selectedFiles.includes(item.id)
                                        ? 'border-stack-primary border-2 bg-stack-primary/5'
                                        : 'border-brand-blue hover:border-stack-primary'
                                "
                                @click="selectionFile(item.id)"
                            >
                                <div
                                    class="flex-shrink-0 w-10 h-10 bg-stack-primary rounded-lg flex items-center justify-center"
                                >
                                    <span
                                        class="text-white text-xs font-bold uppercase leading-none"
                                    >
                                        {{ getFileExt(item.url) }}
                                    </span>
                                </div>

                                <span
                                    class="flex-1 text-sm text-theme-base truncate"
                                >
                                    {{ item.alt || item.url }}
                                </span>

                                <div
                                    v-if="selectedFiles.includes(item.id)"
                                    class="bg-white border-stack-primary border-2 rounded-full p-1"
                                >
                                    <check-icon
                                        class="w-4 h-4 text-stack-primary flex-shrink-0"
                                    />
                                </div>

                                <a
                                    :href="`/app/files/detail/${item.id}`"
                                    target="_blank"
                                    rel="noopener"
                                    class="flex-shrink-0 w-7 h-7 rounded-full bg-theme-input border border-brand-blue flex items-center justify-center text-theme-muted hover:text-stack-primary hover:border-stack-primary transition-colors"
                                    @click.stop
                                >
                                    <pencil-icon class="w-3.5 h-3.5" />
                                </a>
                            </button>
                        </div>
                        <div v-else class="w-11/12 mx-auto mt-6 text-center">
                            <span class="text-theme-muted text-sm">
                                No se encontraron resultados. Intenta modificar
                                los filtros de búsqueda.
                            </span>
                        </div>
                    </div>
                </div>
            </app-dialog>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import CheckIcon from "@/components/icons/CheckIcon.vue";
import ChevronDownIcon from "@/components/icons/ChevronDownIcon.vue";
import ChevronLeftIcon from "@/components/icons/ChevronLeftIcon.vue";
import ChevronUpIcon from "@/components/icons/ChevronUpIcon.vue";
import PencilIcon from "@/components/icons/PencilIcon.vue";
import PlusIcon from "@/components/icons/PlusIcon.vue";
import ReloadIcon from "@/components/icons/ReloadIcon.vue";
import TrashIcon from "@/components/icons/TrashIcon.vue";
import AppDialog from "@/components/utils/AppDialog.vue";
import CustomInput from "@/components/utils/CustomInput.vue";
import FileUploader from "@/components/utils/FileUploader.vue";

export default {
    name: "FilesManage",
    components: {
        AppDialog,
        CheckIcon,
        ChevronDownIcon,
        ChevronLeftIcon,
        ChevronUpIcon,
        CustomInput,
        FileUploader,
        PencilIcon,
        PlusIcon,
        ReloadIcon,
        TrashIcon
    },
    model: {
        prop: "itemsCurrent",
        event: "change"
    },
    props: {
        itemsCurrent: {
            type: Array,
            default: () => [
                {
                    alt: "alt",
                    id: 1,
                    sequence: { sequence: 1 },
                    private: false,
                    url: ""
                }
            ],
            required: true
        },
        id: {
            type: String,
            default: () => "0",
            required: true
        },
        message: {
            type: String,
            default: () => "product",
            required: false
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["change"],
    data: () => ({
        selectFile: false,
        selectedFiles: [],
        isLoading: false,
        currentPage: 1,
        pagesNumber: 0,
        isOpenFileCreator: false,
        filesList: [],

        itemsNumber: 0,
        file: { id: null, name: "" },
        backup: {
            items: [],
            pagination: { pagesNumber: 1, itemsNumber: 1 }
        },
        keyword: ""
    }),
    computed: {
        ...mapState("files", ["files"]),
        ...mapGetters("control", ["backgroundColor", "borderCardDark"])
    },
    watch: {
        keyword(value) {
            if (value) {
                this.filesList = this.files.filter((item) =>
                    item.alt.includes(value.toLowerCase())
                );
                this.itemsNumber = this.filesList.length;
                this.pagesNumber = 1;
                this.currentPage = 1;
            } else {
                this.filesList = [...this.backup.items];
                this.itemsNumber = Number(this.backup.pagination.itemsNumber);
                this.pagesNumber = Number(this.backup.pagination.pagesNumber);
            }
        }
    },
    mounted() {},
    methods: {
        ...mapActions("files", ["listFilesPaginated"]),
        getFileExt(url) {
            return url
                .split("")
                .reverse()
                .join("")
                .split(".")[0]
                .split("")
                .reverse()
                .join("")
                .toUpperCase()
                .slice(0, 4);
        },
        async openNewItem() {
            this.selectFile = true;
            this.listItems(true);
        },
        async loadMoreFiles() {
            this.currentPage = this.currentPage + 1;
            await this.listItems();
        },
        async reloadItems() {
            this.keyword = "";
            this.currentPage = 1;
            await this.listItems(true);
        },
        async advanceSearch() {
            this.currentPage = 1;
            await this.listItems(true);
        },
        async listItems(complete = false) {
            this.isLoading = true;
            try {
                const { items, pagination } = await this.listFilesPaginated({
                    page: this.currentPage,
                    keyword: this.keyword,
                    complete
                });
                this.filesList = items;
                if (pagination) {
                    this.itemsNumber = pagination.itemsNumber;
                    this.pagesNumber = pagination.pagesNumber;
                }
                this.backup = {
                    items,
                    pagination: {
                        itemsNumber: Number(this.itemsNumber),
                        pagesNumber: Number(this.pagesNumber)
                    }
                };
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        moveOrder(fromIndex, toIndex) {
            let arrAux = [...this.itemsCurrent];
            const aux = arrAux[fromIndex];
            arrAux.splice(fromIndex, 1);
            arrAux.splice(toIndex, 0, aux);
            const filesResult = arrAux.map((item, index) => ({
                ...item,
                sequence: { sequence: index }
            }));
            this.$emit("change", filesResult);
        },
        selectionFile(id) {
            let fromIndex = this.selectedFiles.findIndex((item) => item === id);
            if (fromIndex === -1) {
                this.selectedFiles.push(id);
            } else {
                this.selectedFiles.splice(fromIndex, 1);
                let arrAux = [...this.itemsCurrent];
                fromIndex = arrAux.findIndex((item) => item === id);
                if (fromIndex !== -1) {
                    arrAux.splice(fromIndex, 1);
                    this.$emit("change", arrAux);
                }
            }
        },
        pushNewFile() {
            let filesAux = this.filesList.filter((i) =>
                this.selectedFiles.includes(i.id)
            );
            if (filesAux.length) {
                const filesResult = [...this.itemsCurrent];

                filesAux = filesAux.map((item, index) => ({
                    ...item,
                    sequence: { sequence: this.itemsCurrent.length + index }
                }));
                filesAux = [...filesResult, ...filesAux];

                filesAux = filesAux.filter(
                    (value, index, self) =>
                        self.findIndex((item) => item.id === value.id) === index
                );
                this.selectFile = false;
                this.$emit("change", filesAux);
            }
        },
        deleteFile(fromIndex) {
            let filesResult = [...this.itemsCurrent];
            filesResult.splice(fromIndex, 1);
            this.$emit("change", filesResult);
        },
        selectionUploadFile(data) {
            this.filesList.unshift({ ...data, uploaded: false });
            this.selectedFiles.unshift(data.id);
            this.isOpenFileCreator = false;
        },
        onLoading(value) {
            this.isLoading = value;
        }
    }
};
</script>
